export const SUCCESS_MSG = (type) => {
    return `Your request for ${type} action is successfuly submitted`;
};
export const ERROR_MSG = "There is some techincal error. Please try again";

export const FLUSH_NON_PROD_CDN = "https://gafvso.visualstudio.com/Residential%20Warranty/_build?definitionId=2973";